import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import BrokenImageIcon from "@mui/icons-material/BrokenImage";

import StyledRoot, { classes } from "../../utils/pageStyles";

export const NotFound = () => (
  <StyledRoot className={classes.paper}>
    <Avatar className={classes.avatar}>
      <BrokenImageIcon />
    </Avatar>
    <Typography component="h1" variant="h5">
      Página não encontrada
    </Typography>
  </StyledRoot>
);
